{
  "version": 1,
  "asset_id": "7dd1b52a-6fa1-4788-be72-cc0c8cfd5dee",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7dd1b52a-6fa1-4788-be72-cc0c8cfd5dee/hiatal-type-3-story-hernia-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7dd1b52a-6fa1-4788-be72-cc0c8cfd5dee/hiatal-type-3-story-hernia-480.webp",
  "original_filename": "hiatal-type-3-story-hernia-480.webp",
  "size": 20002,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:13Z"
}
